(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bekka-builder-entry')) {
  customElements.define('bekka-builder-entry', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link) return;
        const section = this.closest('.shopify-section');
        const variant = section?.querySelector('product-form-component input[name="id"]')?.value || new URL(location.href).searchParams.get('variant');
        if (!variant) return;
        const url = new URL(link.href);
        if (this.dataset.bundle === 'true') url.searchParams.set('variant', variant);
        if (this.hasAttribute('data-v-part-variants')) {
          url.searchParams.set('type', this.dataset.vPartVariants.split(',').includes(variant) ? 'v' : 'u');
        }
        link.href = url.href;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
